import classNames from "classnames";
import { get, isEmpty } from "lodash";
import AutoSelect from "PFComponents/select/autoselect";
import React, { useMemo } from "react";
import { Controller, ErrorOption, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { PropertyFieldProps } from "../property";
import css from "./properties_fields.module.scss";

type OptionItem = {
  id: string;
  text: string;
  item: string;
};

export const SelectManyField = ({
  fieldName,
  label,
  options,
  required,
  disabled,
  validate,
  className
}: PropertyFieldProps) => {
  const {
    control,
    formState: { errors },
    watch
  } = useFormContext();

  const { t } = useTranslation("saasAdmin");
  const value = watch(fieldName);

  const selectOptions = useMemo<OptionItem[]>(
    () =>
      (options || []).map((option) => ({
        id: option,
        item: option,
        text: option
      })),
    [options]
  );

  return (
    <Controller
      name={fieldName}
      control={control}
      disabled={isEmpty(value)}
      rules={{
        required: required && t("filtersConfig.errors.required"),
        validate: (value) => validate?.(value) || true
      }}
      render={({ field }) => {
        const values = (field.value || []).map((value) => ({ id: value, text: value }));

        return (
          <AutoSelect
            // @ts-ignore
            label={`${label}${required ? " *" : ""}`}
            kind="bordered"
            values={values}
            query={(term) => Promise.resolve(selectOptions.filter((option) => option.text.includes(term)))}
            error={(get(errors, field.name) as unknown as ErrorOption)?.message}
            handleChange={(newValue: OptionItem[]) => field.onChange(newValue.map((value) => value.text))}
            rootClassName={classNames(css.multiSelectField, className)}
            disabled={disabled}
            multi
          />
        );
      }}
    />
  );
};
